export const getApiBaseUrl = () => process.env.CUSTOMER_ACCOUNT_API_GATEWAY_BASE_URL || '';

export const API_VERSION = 'v2';

export default { getApiBaseUrl, API_VERSION };
